import React, { useCallback } from 'react';

/**
 * ExternalLink - A link component that opens URLs in external browser
 *
 * When running inside the native app wrapper (WebView), it uses postMessage
 * to tell the native app to open the URL in Safari/Chrome.
 * When running in a regular browser, it uses target="_blank".
 *
 * @param {Object} props
 * @param {string} props.href - The URL to open
 * @param {React.ReactNode} props.children - Link content
 * @param {string} [props.className] - CSS classes
 * @param {string} [props.testId] - Test ID for e2e testing
 * @param {Object} [props.style] - Inline styles
 */
export const ExternalLink = ({
  href,
  children,
  className,
  testId,
  style,
  ...rest
}) => {
  const handleClick = useCallback((e) => {
    // Check if running inside native wrapper
    if (window.isNativeWrapper && window.ReactNativeWebView) {
      e.preventDefault();
      // Send message to native app to open URL externally
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'openExternal',
        payload: { url: href }
      }));
    }
  }, [href]);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      onClick={handleClick}
      data-testid={testId}
      {...rest}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
